import DashBoard from '@/views/DashBoard.vue';

import CampaignView from '@/views/campaign/CampaignView.vue';
import EditCoupons from '@/views/campaign/EditCoupons.vue';
import CouponPreview from '@/views/campaign/CouponPreview.vue';

import EditProfile from '@/views/EditProfile.vue';
import EditOrganization from '@/views/EditOrganization.vue';
import InviteColleague from '@/views/InviteColleague.vue';

import HistoricalStatistics from '@/views/Statistics.vue';
import DealCalculator from '@/views/deal_calculator/DealCalculatorView.vue';
import BeaconData from '@/views/BeaconData.vue';
import Support from '@/views/Support.vue';

import Login from '@/views/Login.vue';
import Register from '@/views/Register.vue';

import NotFound from '@/views/NotFound.vue';
import Forbidden from '@/views/Forbidden.vue';
import vueI18n from '@/plugins/i18n';
import CreateAccount from '@/views/CreateAccount.vue';


const ROUTES = {
  login: {
    path: '/login',
    component: Login,
    meta: {
      noLoginRequired: true,
    },
  },

  invite_colleague: {
    path: '/invite_colleague',
    component: InviteColleague,
    meta: {
      adminOnly: true,
      get text() { return vueI18n.t('cms.menu.AddColleague'); },
      icon: 'addcolleague',
      includeInNavigation: true,
    },
  },

  create_account: {
    path: '/create-account',
    component: CreateAccount,
    meta: {
      noLoginRequired: true,
    },
  },

  register: {
    path: '/register/:inviteCode',
    component: Register,
    meta: {
      noLoginRequired: true,
    },
  },

  dashboard: {
    path: '/',
    component: DashBoard,
  },

  statistics: {
    path: '/history_statistics',
    component: HistoricalStatistics,
    meta: {
      icon: 'stats',
      get text() { return vueI18n.t('cms.menu.HistoryStatistics'); },
      includeInNavigation: true,
    },
  },

  deal_calculator: {
    path: '/deal_calculator',
    component: DealCalculator,
    meta: {
      icon: 'sliders',
      get text() { return vueI18n.t('cms.menu.DealCalculator'); },
      includeInNavigation: true,
      noLoginRequired: true,
    },
  },

  campaign_view: {
    path: '/campaigns/:campaignId',
    component: CampaignView,
    meta: {
      get text() { return vueI18n.t('cms.menu.HistoryStatistics'); },
      icon: 'concept',
    },

    children: {
      edit_coupons: {
        path: 'coupons',
        component: EditCoupons,
        meta: {
          get text() { return vueI18n.t('cms.coupon.Header'); },
          icon: 'concept',
        },
      },

      coupon_preview: {
        path: 'coupon_preview',
        component: CouponPreview,
        meta: {
          get text() { return vueI18n.t('cms.view.Header'); },
          icon: 'eye',
        },
      },
    },
  },

  edit_profile: {
    path: '/edit_profile',
    component: EditProfile,
    meta: {
      get text() { return vueI18n.t('cms.editProfile.Header'); },
      icon: 'roller',
    },
  },

  edit_organization: {
    path: '/edit_organization',
    component: EditOrganization,
    meta: {
      get text() { return vueI18n.t('cms.editOrganization.Header'); },
      icon: 'roller',
    },
  },

  beacon_data: {
    path: '/beacon_data',
    component: BeaconData,
    meta: {
      get text() { return vueI18n.t('cms.menu.BeaconSettings'); },
      icon: 'settings',
      includeInNavigation: true,
    },
  },

  support: {
    path: '/support',
    component: Support,
    meta: {
      get text() { return vueI18n.t('cms.menu.Support'); },
      icon: 'at',
      includeInNavigation: true,
    },
  },

  forbidden: {
    path: '/forbidden',
    component: Forbidden,
    meta: {
      text: 'Forbidden',
      icon: 'cancel',
    },
  },

  not_found: {
    path: '*',
    component: NotFound,
    meta: {
      text: 'Not found',
      noLoginRequired: true,
    },
  },
};

export default ROUTES;
